<template>
  <div class="main-notification">
    <div class="notification">
      <h2 class="title">اعلانات</h2>
      <div class="" v-if="!notfications">اعلانی جهت نمایش وجود ندارد</div>
      <div class="drop-items" v-for="(item , index) in notfications" :key="index">
        <the-drop-down :data="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import TheDropDown from "../tools/the-drop-down";

export default {
  name: "the-notification",
  components: {TheDropDown},
  data() {
    return {
      notfications:[]
      // notfications: [
      //   {
      //     title: 'پیام شما در رایچت پاسخ داده شده',
      //     date: '00/12/03 | 14:33',
      //     content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
      //   },
      //   {
      //     title: 'پیام شما در رایچت پاسخ داده شده',
      //     date: '00/12/03 | 14:33',
      //     content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
      //   },
      //   {
      //     title: 'پیام شما در رایچت پاسخ داده شده',
      //     date: '00/12/03 | 14:33',
      //     content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
      //   },
      //   {
      //     title: 'پیام شما در رایچت پاسخ داده شده',
      //     date: '00/12/03 | 14:33',
      //     content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
      //   },
      //   {
      //     title: 'پیام شما در رایچت پاسخ داده شده',
      //     date: '00/12/03 | 14:33',
      //     content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود.'
      //   },
      // ]
    }
  },
  methods:{
   async getNotifications() {
      const res = await this.$axios('/users/notifications');
      console.log('notifs',res.content);
      this.notfications = res.content;

    }
  },
  mounted() {
    this.getNotifications();
  }
}
</script>

<style lang="scss" scoped>
.main-notification {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background-image: url("../../assets/backgrounds/qa-bg.png");
  background-size: cover;
  background-position: center;


  .notification {
    width: 90%;
    margin: 100px 0;

    .title {
      width: 100%;
      color: #FBFBFD;
      text-align: right;
      margin-bottom: 100px;
    }
  }
}
</style>